import { GET_GAME_ENABLED_FIRST } from './gql'

import type { GetFirst } from './types'
import { graphClient } from '../../graph-client.ts'

class GameEnabledService {
  async getFirst() {
    const request = await graphClient.request<GetFirst.Output>(
      GET_GAME_ENABLED_FIRST,
    )

    return request?.getGameEnabledFirst
  }
}

export const gameEnabledService = new GameEnabledService()
